import React from "react";
import { Link } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import { slide as Menu } from "react-burger-menu";
import _ from "underscore";
import { Nav, NavItem } from "react-bootstrap";
import { observer } from "mobx-react";
import { ToastContainer } from "react-toastify";
import BirdLogo from "../../assets/BirdLogo.png";
import HttpUtils from "src/utils/HttpUtils";

const Sidebar = (props) => {
  return (
    // Pass on our props
    <Menu {...props}>
      <a style={{ userSelect: "none" }} className="menu-item" href="/">
        Home
      </a>

      <a
        style={{ userSelect: "none" }}
        className="menu-item"
        href="/projectDefinition"
      >
        About BIRD
      </a>

      <a style={{ userSelect: "none" }} className="menu-item" href="/nav">
        Navigator
      </a>

      <a style={{ userSelect: "none" }} className="menu-item" href="/cm">
        Metadata & Exports
      </a>
    </Menu>
  );
};

@observer
export class BirdHeaderHomepage extends React.Component {
  componentDidMount() {
    window.onresize = function () {
      this.forceUpdate();
    }.bind(this);
  }
  styles = {
    HeaderContainer: {
      background: "#003299",
      height: "50px",
      position: "fixed",
      width: "100%",
      zIndex: 1001,
      top: 0,
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
    },
    HeaderTitle: {
      fontSize: "15px",
      color: "white",
      display: "flex",
      alignSelf: "center",
      minWidth: "300px",
      width: "100%",
    },
    HeaderNavItems: {
      display: "flex",
      justifyContent: "space-evenly",
      minWidth: "800px",
      width: "100%",
    },
  };
  render() {
    let minStyles = {
      HeaderNavItems: {
        display: "none",
      },
      HeaderLogo: {
        display: "none",
      },
      HeaderTitle: {
        fontSize: "15px",
        color: "white",
        display: "flex",
        maxWidth: "200px",
        margin: "auto",
        width: "100%",
      },
    };

    let maxStyles = _.extend({}, minStyles, {
      HeaderNavItems: {
        display: "flex",
        justifyContent: "space-evenly",
        minWidth: "200px",
        width: "100%",
        fontSize: "13px",
        fontWeight: 600,
        maxWidth: "600px",
      },
      HeaderLogo: {
        marginLeft: "50px",
        cursor: "default",
        display: "flex",
        alignItems: "center",
        height: "100%",
        maxHeight: "50px",
        justifyContent: "center",
      },
      HeaderTitle: {
        fontSize: "22px",
        color: "white",
        display: "flex",
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
        minWidth: "550px",
        width: "100%",
      },
    });
    let style = function () {
      if (window.innerWidth < 1100) {
        return minStyles;
      } else {
        return maxStyles;
      }
    };

    return (
      <>
        <div style={this.styles.HeaderContainer}>
          {window.innerWidth < 1100 ? (
            <Sidebar
              pageWrapId={"page-wrap"}
              outerContainerId={"App"}
            ></Sidebar>
          ) : null}
          <div style={style().HeaderLogo}>
            <Link style={{ maxHeight: "50px" }} to="/">
              <img
                src={BirdLogo}
                alt="BIRD logo"
                style={{
                  height: "100%",
                  Width: "100%",
                  maxHeight: "50px",
                }}
              />
            </Link>
          </div>
          <div style={style().HeaderTitle}>
            The Banks' Integrated Reporting Dictionary
          </div>
          <Nav
            style={style().HeaderNavItems}
            activeKey={null}
            className="nav-without-before-and-after"
          >
            <LinkContainer to="/projectDefinition">
              <NavItem className="nav-item-link-transparent-underlined">
                About BIRD
              </NavItem>
            </LinkContainer>
            <LinkContainer to={"/nav"}>
              <NavItem className="nav-item-link-transparent-underlined">
                Navigator
              </NavItem>
            </LinkContainer>
            <LinkContainer to={"/cm"}>
              <NavItem className="nav-item-link-transparent-underlined">
                Metadata & Exports
              </NavItem>
            </LinkContainer>
          </Nav>
        </div>

        {HttpUtils.computed_bool_isSpiner ? (
          <div id="ecb_appjs_spinner_element">
            <div className="loader"></div>
          </div>
        ) : null}

        <ToastContainer
          position="top-right"
          autoClose={10000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          style={{ zIndex: 9999, top: 50 }}
        />
      </>
    );
  }
}
